export const CoreInitiativesFilesByIdName = 'CoreInitiativesFilesById';
